import { render } from "./FridgeDoorMonitorPage.vue?vue&type=template&id=5b477426&scoped=true&ts=true"
import script from "./FridgeDoorMonitorPage.vue?vue&type=script&lang=ts"
export * from "./FridgeDoorMonitorPage.vue?vue&type=script&lang=ts"

import "./FridgeDoorMonitorPage.vue?vue&type=style&index=0&id=5b477426&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b477426"]])

export default __exports__